import template from './templates/filters-subgroup.html';

export default function FlightFilterSubgroup() {
    return {
        template,
        restrict: 'E',
        scope: {
            filterKey: '@',
            label: '@',
            filters: '=',
            updateFilters: '=',
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/filters-subgroup-directive.js